//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from "@/components/common/footer";
import Header from "@/components/common/header";
import Right from "@/components/common/Right";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "index",
  data() {
    return {
      banners: [],
      swiperOption1: {
        notNextTick: true,
        autoplay: true,
        delay: 1500,
        loop: true,
        slidesPerView: "auto",
        centeredSlides: true,
        paginationClickable: true,
        // spaceBetween: 30,
        onSlideChangeEnd: (swiper) => {
          //这个位置放swiper的回调方法
          this.page = swiper.realIndex + 1;
          this.index = swiper.realIndex;
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      zhibo: [],
      news_type: [], //新闻类型,里面包含新闻列表
      help_link: [],
      floorplan: {
        floorplan_one: "",
        floorplan_two: "",
        floorplan_three: "",
      },
      video_name: "在线视频",
      adverts: [], //飘窗广告
      semesterList: [],
    };
  },
  mounted() {
    var that = this;
    //获取直播列表
    this.$axios
      .post(`/v5/bro/show_bro`, {
        type: 2,
      })
      .then((res) => {
        if (res.data.code == 200) {
          this.zhibo = res.data.data;
          this.video_name = res.data.video_name;
        }
      });
    //轮播图
    this.$axios.post(`/v8/PC_index/PC_index_banner`).then((res) => {
      this.banners = res.data.data;
    });
    //获取新闻分类和数据  2021-05-26 by 灰熊
    this.$axios.post("v8/index/getNewsTypeList", {}).then((res) => {
      if (res.data.code == 0) {
        that.news_type = res.data.data;
      }
    });
    // 获取友情链接
    this.$axios.post("v8/index/getHelplink", {}).then((res) => {
      if (res.data.code == 0) {
        that.help_link = res.data.data;
      }
    });
    // 获取友情链接
    this.$axios.post("v8/index/getFloorplan", {}).then((res) => {
      if (res.data.code == 0) {
        that.floorplan = res.data.data;
      }
    });
    // 获取飘窗
    this.$axios
      .post(`/v8/index/advertLink`, { source: "index" })
      .then((res) => {
        if (res.data.code == 0) {
          that.adverts = res.data.data;
        }
      });
    // 获取培训班课程
    this.$axios.post(`/v9/index/getAppTerm`, {}).then((res) => {
      if (res.data.code == 0) {
        that.semesterList = res.data.data;
      }
    });
  },
  methods: {
    zhibocli(id, link_url = "", is_attributes = 0, broadcast_status = 3) {
      if (link_url.length > 0) {
        window.open(link_url);
        return false;
      }
      //判断是否登录，若token == null未登录，展示无需认证的直播详情页 季克广 2020.08.15
      //  季克广 2020.12.7, 添加一个参数broadcast_status，判断是否回放，是，则跳转到zhiboingVod
      let token = localStorage.getItem("TOKEN");
      if (is_attributes == 0) {
        if (token == null) {
          this.$router.push("/zhiboingNoAuth?id=" + id);
        } else {
          if (broadcast_status === 3) {
            this.$router.push("/zhiboingVod?id=" + id);
          } else {
            this.$router.push("/zhiboing?id=" + id);
          }
        }
      } else {
        this.$router.push("/zhiboing1?id=" + id);
      }
    },
    toPage(a) {
      this.$router.push(a);
    },
    goLinke: function (jion = 1, link = "#") {
      if (jion == 1) {
        //外联
        window.open(link);
      } else {
        this.$router.push(link);
      }
    },
  },

  created() {},
  components: {
    Header,
    Footer,
    Right,
    swiper,
    swiperSlide,
  },
};



// WEBPACK FOOTER //
// ./src/components/index/index.vue